var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-4"},[_c('BackButton'),_c('h1',{staticClass:"mt-4"},[_vm._v("Map")]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-primary card p-4 mt-4"},[_c('img',{staticClass:"w-100",attrs:{"src":"/map23.jpeg","alt":""}})])
}]

export { render, staticRenderFns }